export default {
  methods: {
    generateDownloadLink(file) {
      return `/api/tasks/attachments/${file.public_id}/download`;
    },
  },
};
